import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { columns, generateData } from './Columns';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import {
  SimpleDialog,
  InputV2,
  ConfirmDialog,
  ButtonLoading,
  TableComponents,
  FilterPod,
  Icons
} from 'components';
import { getDynamicObjectAction } from 'utility';
import copy from 'copy-to-clipboard';
import createToast from 'components/Toast/Toast';
import CardsServices from '../../services';
import { useStyles } from './style';
import useCustomHook from './hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

// TODO: add auto validation (rules) for Card Number

const CardsList = (props) => {
  const classes = useStyles();
  let tableRef = useRef();
  const currentLoaction = useLocation();

  // -- HOOKS --//
  const {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    isLoading,
    setIsLoading,
    filters,
    setFilters,
    list,
    setList,
    isSubmitting,
    setIsSubmitting,
    isNewDialogOpen,
    setIsNewDialogOpen,
    confirmDeleteModal,
    setConfirmDeleteModal,
    itemIdToDelete,
    setItemIdToDelete,
    currentId,
    setCurrentId,
    cardNumber,
    setCardNumber,
    cardName,
    setCardName,
    page,
    setPage,
    isLoadingDelete, setIsLoadingDelete
  } = useCustomHook();
  let actionsList = getDynamicObjectAction([
    'cardsNewCardPage',
    'cardsImprestNewCardPage',
    'cardsDeleteCardPage',
    'cardsImprestDeleteCardPage',
    'cardsUpdateCardPage',
    'cardsImprestUpdateCardPage'
  ]);
  useEffect(() => {
    //getItems();
  }, []);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const getItems = async (query) => {
    try {
      setIsLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      setPage(query?.page);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await CardsServices.getCards(params);

      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setIsLoading(false);
      const da = res?.result;
      setList(da);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };

      }
    }
  };

  const postItem = async () => {
    try {
      if (!cardNumber || cardNumber.length == 0) {
        createToast('خطا', 'شماره کارت را وارد کنید.', 'danger');

        return;
      }
      if (!cardName || cardName.length == 0) {
        createToast('خطا', 'عنوان کارت را وارد کنید.', 'danger');

        return;
      }

      const cardNum = cardNumber.replaceAll('-', '');
      if (cardNum.length != 16) {
        createToast('خطا', 'شماره کارت باید ۱۶ عدد باشد.', 'danger');

        return;
      }

      setIsSubmitting(true);
      const body = {
        cardNumber: cardNum,
        name: cardName,
        cvv2: null,
        expiryMonth: null,
        expiryYear: null,
        order: null,
        tag: [],
      };
      const result = await CardsServices.postCard(body);
      createToast('موفق', 'کارت جدید با موفقیت ایجاد شد', 'success');
      handleCloseNew();
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);

    }
  };

  const putItem = async () => {
    try {
      if (!cardNumber || cardNumber.length == 0) {
        createToast('خطا', 'شماره کارت را وارد کنید.', 'danger');
        return;
      }
      if (!cardName || cardName.length == 0) {
        createToast('خطا', 'عنوان کارت را وارد کنید.', 'danger');
        return;
      }
      const cardNum = cardNumber.replaceAll('-', '');
      if (cardNum.length != 16) {
        createToast('خطا', 'شماره کارت باید ۱۶ عدد باشد.', 'danger');
        return;
      }
      setIsSubmitting(true);

      const selectedItem = list.find((v) => v?.id == currentId);
      if (!selectedItem) return;
      const body = {
        cardNumber: cardNum,
        name: cardName,
        cvv2: selectedItem?.cvv2,
        expiryMonth: selectedItem?.expiryMonth,
        expiryYear: selectedItem?.expiryYear,
        order: selectedItem?.order,
        tag: selectedItem?.tag,
      };
      const result = await CardsServices.putCard(currentId, body);
      createToast('موفق', 'اطلاعات کارت با موفقیت بروزرسانی شد', 'success');

      handleCloseNew();
      setIsSubmitting(false);
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      setIsSubmitting(false);

    }
  };

  const deleteItem = async () => {
    if (!itemIdToDelete) return;
    try {
      setIsLoadingDelete(true)
      const result = await CardsServices.deleteCard(itemIdToDelete);
      setItemIdToDelete(null);
      setConfirmDeleteModal(false);

      createToast('موفق', 'کارت با موفقیت حذف شد.', 'success');
      setPage(0)
      setSize(10)
      setIsLoadingDelete(false)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      console.log(error);
      setIsLoadingDelete(false)
    }
  };

  const postDefault = async (id) => {
    if (!id) return;
    try {
      const result = await CardsServices.postDefaultCard(id);
      createToast('موفق', 'کارت پیش‌فرض با موفقیت تغییر یافت.', 'success');
      setPage(0)
      setSize(10)
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
    } catch (error) {
      console.log(error);
    }
  };

  // -- OTHER FUNCTIONS --//
  const handleCloseNew = () => {
    setIsNewDialogOpen(false);
    setCardName('');
    setCardNumber('');
    setCurrentId(null);
  };

  const formatCardNumber = (no) => {
    let noStr = `${no}`;
    const arr = noStr.match(/.{1,4}/g);
    noStr = '';
    arr.map((v, k) => (noStr += `${v}${k != arr.length - 1 ? ' - ' : ''}`));
    return noStr;
  };

  const handleOnEdit = (item) => {
    setCurrentId(item?.id);
    setCardNumber(item?.number);
    setCardName(item?.name);
    setIsNewDialogOpen(true);
  };

  const copyItem = async (v) => {
    try {
      await copy(v);
      createToast('موفق', 'شماره کارت کپی شد.', 'success');
    } catch (e) {
      console.log(e);
    }
  };
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };
  return (
    <div>
      <SimpleDialog
        title="تعریف شماره کارت جدید"
        open={isNewDialogOpen}
        icon={<Icons icon='Banking' color='#2B3990' size='24' />}
        onClose={handleCloseNew}
        actions={
          <>
            <ButtonLoading
              name={`ثبت و ${currentId ? 'تایید' : 'افزودن کارت'}`}
              loading={isSubmitting}
              variant="contained"
              color="primary"
              startIcon={<Icons icon='plusCircle' color="#fff" size="18" />}
              onClick={currentId ? putItem : postItem}
            />
            <Button variant="contained" onClick={handleCloseNew}>
              انصراف
            </Button>
          </>
        }
      >
        <Typography className={classes.newItemHint}>
          در این صفحه می‌توانید شماره کارت بانکی جدید تعریف کنید.
        </Typography>
        <Grid>
          <InputV2
            masked
            mask={[
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ]}
            errors={{}}
            rules={['required']}
            dir="ltr"
            name="cardNumber"
            label="شماره کارت را وارد کنید"
            placeholder="با اعداد انگلیسی"
            forceValue={cardNumber}
            mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
            fullWidth
            defaultValue={null}
            onChangeValue={(e) => setCardNumber(e?.target?.value)}
          />
        </Grid>
        <InputV2
          errors={{}}
          rules={['required']}
          name="cardName"
          label="عنوان کارت بانکی را وارد کنید"
          mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
          forceValue={cardName}
          fullWidth
          placeholder="مثلا:‌حساب خرج‌های روزانه"
          defaultValue={null}
          onChangeValue={(e) => setCardName(e?.target?.value)}
        />
      </SimpleDialog>
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
          {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') ? actionsList['cardsImprestNewCardPage'] : actionsList['cardsNewCardPage']) && (
            <Button
              onClick={() => setIsNewDialogOpen(true)}
              color="primary"
              variant="contained"
              startIcon={<Icons icon='plusCircle' color='#fff' size='18' />}

            >
              شماره کارت جدید
            </Button>
          )}
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>

      <TableComponents
        data={getItems}
        columns={columns(postDefault, copyItem, formatCardNumber, actionsList, currentLoaction, handleOnEdit, setItemIdToDelete, setConfirmDeleteModal)}
        isLoading={isLoading}
        ref={tableRef}
        onChange={(ps) => {
          setPage(ps?.pageNumber)
          setSize(ps?.pageSize)
          return getItems(ps)
        }}
      />

      <ConfirmDialog
        loading={isLoadingDelete}
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={deleteItem}
        title="تایید حذف کارت"
        content="آیا از حذف کارت انتخاب شده اطمینان دارید؟"
        confirmButtonText="حذف کارت"
        cancelButtonProps="انصراف"
      />
    </div>
  );
};

export default CardsList;
